// extracted by mini-css-extract-plugin
export default {"container":"PendingActivityState_container__T2AKm","title":"PendingActivityState_title__Tlt9u"};